import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { EmployeeEntityGrid } from '../features/employee-entity-grid';

export const AllEmployeePage = observer(() => {
  return (
    <AppPage perm="PERM_EMPLOYEE_CREATE" noWrapper>
      <EmployeeEntityGrid />
    </AppPage>
  );
});
